"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default2 = exports.default = {
  name: 'CustomersTable',
  props: {
    data: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    isLoading: {
      type: Boolean,
      default: false
    }
  },
  emits: ['edit', 'delete'],
  computed: {
    tableData: function tableData() {
      return Array.isArray(this.data) ? this.data : [];
    }
  },
  methods: {
    formatDate: function formatDate(value) {
      if (!value) return '--';
      return new Date(value).toLocaleDateString();
    }
  }
};